import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
  FormGroup,
  FormControlLabel,
  Checkbox,Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    backgroundColor: 'transparent',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
  },
  '& .Mui-focused': {
    borderColor: '#673ab7',
  },
  '& .MuiFilledInput-root.Mui-focused': {
    border: '1px solid #673ab7',
  },
}));

const columns = [
  { id: 'RowNum', label: 'S.No.', minWidth: 170 },
  { id: 'RoomTypeName', label: 'Type', minWidth: 100 },
  { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const RoomType = () => {
  const [formData, setFormData] = useState({
    RoomTypeName: '',
    Remark: ''
  });

  // const permissions = useModulePermissions("Room Type Master");

  const [error, setError] = useState({
    roomTypeName: false,
    remark: false
  });

  const navigate = useNavigate();

  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const location = useLocation();
  const [currentRoomTypeId, setCurrentRoomTypeId] = useState(null);
  const [mode, setMode] = useState('view');
  const [lastInsertedRoomTypeId, setLastInsertedRoomTypeId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [Status, setStatus] = useState("1");
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const roomTypeNameRef = useRef(null);
  const remarkRef = useRef(null);

  useEffect(() => {
    if (location.state && location.state.RoomTypeId) {
      setCurrentRoomTypeId(location.state.RoomTypeId);
      fetchRoomTypeData(location.state.RoomTypeId);
      setMode('view');
    } else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  const fetchRoomTypeData = async (id, flag) => {
    try {
      const response = await axios.post(`RoomTypeMst/RetriveRoomTypeMst`, {
        RoomTypeId: parseInt(id),
        Flag: flag
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const roomTypeData = response.data.Data[0];
        setFormData({
          RoomTypeName: roomTypeData.RoomTypeName,
          Remark: roomTypeData.Remark
        });
        setStatus(roomTypeData.Status.toString() || "0");
        setIsFormDisabled(true);
        setCurrentRoomTypeId(roomTypeData.RoomTypeId);
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);
      } else {
        toast.error('Failed to fetch room type data');
      }
    } catch (error) {
      console.error('Error fetching room type data:', error);
      toast.error('Error fetching room type data. Please try again.');
    }
  };

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: ""
      };
  
      try {
        const res = await axios.post('RoomTypeMst/getAllRoomTypeMstDashBoard', { params });
  
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
  
    getRow();
  }, []);

  const handlePrevious = async () => {
    if (currentRoomTypeId && currentRoomTypeId > 1) {
      await fetchRoomTypeData(currentRoomTypeId, "P");
    }
  };

  const handleNext = async () => {
    if (currentRoomTypeId) {
      await fetchRoomTypeData(currentRoomTypeId, "N");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));


    if (name === 'roomtype') {
      setFormData(prevState => ({
        ...prevState,
        state: ''
      }));
    }

    if (name === 'roomtype' && value !== '') {
      setTimeout(() => {
        remarkRef.current.focus();
      }, 100000);
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      remarkRef.current.focus();
    }
  };

  const handleSave = async () => {

    let hasError = false;

    if (!formData.RoomTypeName) {
      toast.error('Room Type Name is required');
      setError(prev => ({ ...prev, roomTypeName: true }));
      hasError = true;
    } else {
      setError(prev => ({ ...prev, roomTypeName: false }));
    }

    if (hasError) {
      return;
    }


    try {
      const payload = {
        RoomTypeName: formData.RoomTypeName,
        Remark: formData.Remark,
        Status: Status
      };

      let response;
      if (mode === 'edit') {
        payload.RoomTypeId = currentRoomTypeId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axios.patch(`RoomTypeMst/UpdateRoomTypeMst`, payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axios.post(`RoomTypeMst/InsertRoomTypeMst`, payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (mode === 'add') {
          setLastInsertedRoomTypeId(response.data.Data)
          await fetchRoomTypeData(response.data.Data);
          setMode('view');
          setIsFormDisabled(true);
          setCurrentRoomTypeId(response.data.Data);
        } else {
          setMode('view');
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message || 'Operation failed');
      }
    } catch (error) {
      console.error('Error saving/updating room type:', error);
      toast.error('Error saving/updating room type. Please try again.');
    }
  };

  const handleEdit = async () => {

    let Flag = await checkAndLock(currentRoomTypeId, "MstRoomType", "RoomTypeId");
    switch (Flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setMode('add');
    setIsFormDisabled(false);
    setFormData({
      RoomTypeName: '',
      Remark: ''
    });
    setCurrentRoomTypeId(null);

    setTimeout(() => {
      roomTypeNameRef.current.focus();
    }, 0);
  };

  const handleCancel = async () => {
    try {
      await fetchRoomTypeData(1, "L");
      await UnLock(currentRoomTypeId, "MstRoomType", "RoomTypeId");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error occurred while cancelling. Please try again.');
    }
  };

  const resetForm = () => {
    setFormData({
      RoomTypeName: '',
      Remark: ''
    });
    setCurrentRoomTypeId(null);
    setMode('view');
  };

  const handleExit = () => {
    navigate('/roomTypetable')
  }

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {

    let Flag = await checkAndLock(currentRoomTypeId, "MstRoomType", "RoomTypeId");
    switch (Flag) {
      case 0:
        setOpenConfirmDialog(false);
        await fetchRoomTypeData(currentRoomTypeId, "D");
        await fetchRoomTypeData(currentRoomTypeId, "N");
        setMode('view');
        setIsFormDisabled(true);
        break;
      case 1: toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });

    }

  };

  return (
    <>

      <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>

        <ToastContainer />
        <Grid container spacing={2} className='form_grid'>
          <Grid item xs={12} className='form_title' 
            sx={{ 
                  display: 'flex', alignItems: 'center', 
                  justifyContent: 'space-between', marginTop: '20px',
                  flexDirection: { xs: 'column', sm: 'row', md: 'row' }  
                }}
              >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                onClick={handlePrevious}
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentRoomTypeId || currentRoomTypeId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                // sx={{ margin: '0px 10px' }}
                className='three-d-button-next'
                onClick={handleNext}
                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentRoomTypeId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            
            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              RoomType Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName={"Room Type Master"}
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleConfirmDelete}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className='form_field'>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={5}>
                <TextField
                  id="RoomTypeName"
                  name="RoomTypeName"
                  label={
                    <span>
                      RoomType <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.RoomTypeName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.roomTypeName}
                  helperText={error.roomTypeName && ""}
                  inputRef={roomTypeNameRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={5}>
                <TextField
                  id="Remark"
                  name="Remark"
                  label="Remark"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Remark}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.remark}
                  helperText={error.remark && ""}
                  inputRef={remarkRef}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={2}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isFormDisabled}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === 'view' && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === 'edit' || mode === 'add') && (
              <>

                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>

              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <ReportTable
          columns={columns}
          rows={rows}
          title="RoomType Master"
          contentRef={contentRef}
          customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default RoomType